import View from 'views/base/view';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import GuidesOverlayTemplate from './templates/guides-overlay';
import Chaplin from 'chaplin';
import $ from 'jquery';

export default class GuidesOverlayView extends View {
  constructor(options) {
    super(options);
    this.autoRender = false;
    this.noWrap = true;
    if (CourseSettingsService.get('guides')) {
      const guides = CourseSettingsService.get('guides')
        .filter(g => g.enabled === true)
        .map(g => {
          const clone = Object.assign({}, g);
          delete clone.enabled;
          return clone;
        });
      this.model = new Chaplin.Model({ guides: guides });
    }
    this.subscribeEvent('addedToDOM', this.load);
    SessionStorageService.setItem('overlayEnabled', true);
  }

  load() {
    this.delegate('click', '.guides-close', () => {
      SessionStorageService.removeItem('overlayEnabled');
      this.dispose();
    });
  }

  render() {
    if (this.model) {
      const template = GuidesOverlayTemplate;
      this.$el = $(template(this.model.attributes));
    }
  }

  attach() {
    $('body').prepend(this.$el);
    this.publishEvent('addedToDOM');
  }
}
